import React from 'react';
import Sidebar from './clever_components/Sidebar';
import Header from './clever_components/Header';
import Axios from 'axios';
//import Footer from './clever_components/Footer';

import CookieConsent, { Cookies, getCookieConsentValue } from "react-cookie-consent";
import ReactGA from 'react-ga4';


import Main from './main';

// https://www.npmjs.com/package/react-device-detect
import {
  BrowserView,
  MobileView,
  browserName,
  isBrowser,
  isMobile,
  isIE, isChrome, isEdge
} from "react-device-detect";

// Environment variables doc  -  to read and implement someday...
// https://medium.com/@trekinbami/using-environment-variables-in-react-6b0a99d83cf5

const CST_GA_DATASTREAM_ID = "G-5Y1NW7R1G7";
const CST_COOKIECONSENT_DEBUG = false;

class App extends React.Component {

  constructor(props) {
		super(props);
    this.state = {
        consentSet: false
    };
		// this.dummyfunction = this.dummyfunction.bind(this);
	}

	componentDidMount() {
		console.log('App: componentDidMount');
		if (getCookieConsentValue("cookieConsent") === undefined) {
			console.log('BANNER DISPLAYED')
			Axios.post('/api/consentEvents/incBannerCount', { counter: 'bannerDisplayed' });
		}

		if (getCookieConsentValue("cookieConsent") === 'true') {
			//console.log('ReactGA.initialize')
			ReactGA.initialize(CST_GA_DATASTREAM_ID); // Remplacez par votre ID de mesure GA4 (LuckyChampions GA4)
		}
	}

  componentDidUpdate(prevProps) {
		//console.log('App: componentDidUpdate');
    const { location } = this.props;
    if (location.pathname !== prevProps.location.pathname) {

			if (getCookieConsentValue("cookieConsent") === 'true') {
				ReactGA.initialize(CST_GA_DATASTREAM_ID); // Remplacez par votre ID de mesure GA4 (LuckyChampions GA4)
			}
      window.scrollTo(0, 0);
    }
  }

  handleAcceptCookies = () => {
		//console.log('handleAcceptCookies')
		//console.log('ReactGA.initialize')
		ReactGA.initialize(CST_GA_DATASTREAM_ID); // Remplacez par votre ID de mesure GA4 (LuckyChampions GA4)

		console.log('CONSENT GRANTED')
		Axios.post('/api/consentEvents/incBannerCount', { counter: 'consentGranted' });

	  // Configuration pour activer GA4 lorsque l'utilisateur accepte les cookies
	  window.dataLayer = window.dataLayer || [];
	  function gtag() { window.dataLayer.push(arguments); }
	  gtag('consent', 'update', {
	    'analytics_storage': 'granted'
	  });
/*
	  gtag('js', new Date());
	  gtag('config', CST_GA_DATASTREAM_ID); // Remplacez 'G-XXXXXXXXXX' par votre ID de mesure GA4
*/
    this.setState({ consentSet: true });
  };

  handleDeclineCookies = () => {
		//console.log('handleDeclineCookies')

		console.log('CONSENT DENIED')
		Axios.post('/api/consentEvents/incBannerCount', { counter: 'consentDenied' });

	  // Configuration pour désactiver le suivi GA4 lorsque l'utilisateur refuse les cookies
	  window.dataLayer = window.dataLayer || [];
	  function gtag() { window.dataLayer.push(arguments); }
	  gtag('consent', 'update', {
	    'analytics_storage': 'denied'
	  });

/*
	  // Cela indique à GA4 de ne pas envoyer de données.
	  window[('ga-disable-' + CST_GA_DATASTREAM_ID)] = true;
	  gtag('config', CST_GA_DATASTREAM_ID, { send_to: 'none' }); // Utilisez votre ID de mesure GA4 ici
		gtag('consent', 'update', { 
	    'ad_storage': 'denied',
			'analytics_storage': 'denied' 
		});
*/
    this.setState({ consentSet: true });
  };

	render() {
		// console.log('App');
		// console.log(this.props);
  	return (
			<React.Fragment>
  		{isIE ? 
    		<div>
  			<h4 className="ieWarning1">IMPORTANT</h4>
  			<h5 className="ieWarning2">Chez Statelo, nous utilisons des technologies avancées qui ne sont pas supportées par Internet Explorer</h5>
  			<h5 className="ieWarning2">Pour une expérience immersive et novatrice, nous vous suggérons d'utiliser Chrome.</h5>
  			<a href="https://www.google.com/intl/fr/chrome/" target="_blank">
    			<h5 className="ieWarning2">
    				<img className="img-fluid" src="/img/chrome_ico.png" alt="chrome" width="50"/>
    			</h5>
    			<h5 className="ieWarning3">
    				Télécharger Chrome
    			</h5>
  			</a>
				</div>
  		:
				<div className="app">
					<Header />
					<div className="app-body">
						<Sidebar history={this.props.history} auth={this.props.auth}/>
						<Main history={this.props.history} auth={this.props.auth}/>
					</div>
				</div>
			}

			<CookieConsent
				onAccept={this.handleAcceptCookies}
				onDecline={this.handleDeclineCookies}
				debug={CST_COOKIECONSENT_DEBUG}
        location="bottom"
        buttonText="Accepter"
        cookieName="cookieConsent"
        enableDeclineButton
        declineButtonText="Refuser"
        declineCookieValue={false}
        style={{ background: "#003200" }}
        buttonStyle={{ background:"#f5fff5", color: "black", fontSize:"13px", width: "100px", borderRadius: "3px"}}
        declineButtonStyle={{background:"#f5fff5", color: "black", fontSize: "13px", width: "100px", borderRadius: "3px"}}
        expires={183}>

				Ce site utilise les témoins de navigations tel que décris dans notre <a href="/confidentialite" className="whitelink">politique de confidentialité.</a>
			</CookieConsent>


			</React.Fragment>
		)
	}

}

export default App;
